module.exports = __webpack_public_path__ + "img/icons-groups.29180b0.svg";